// dataLoad page strings. Keys are read as $t('dataLoad.<key>').
export default {
  en: {
    title: 'Data Load',
    subtitle: 'Pick a file, then Submit. Only one upload can be armed at a time.',
    roles: {
      planning: 'PLANNING',
      cash: 'CASH ACCOUNTANT',
      colsIns: 'COLS INS',
    },
    steps: {
      loadNoteDb: 'Load special notes',
      checkPlanning: 'Check planning file',
      processPlanning: 'Process planning data',
      checkPayment: 'Check payment',
      processPayment: 'Process payment',
      processPaymentNote: '(Creates customers in the system - PLANNING uses it to create customers)',
      closeFile: 'Close planning and payment file',
      colsIns: 'Upload Cols Ins',
      colsInsNote: 'Only "colInstruction YYYYMMDD.xlsx" newer than the current version; the file is test-run against the standard planning file before it is saved.',
    },
    file: {
      noteDb: 'Special notes file',
      planning: 'Planning file',
      colsIns: 'ColsIns file',
    },
    cancel: 'Cancel',
    submit: 'Submit',
    close: 'Close',
    colsInsCard: {
      title: 'ColsIns files',
      standard: 'Standard planning file',
      standardMissing: 'None yet — saved after the next successful "Process planning data"',
      current: 'colInstruction in use',
      noWrite: 'The server cannot write to {path} — contact an admin.',
      fileHeader: 'File',
    },
    download: {
      title: 'Download file?',
      body: 'Do you want to download {file}?',
      cancel: 'Cancel',
      confirm: 'Download',
      failed: 'Could not download the file',
    },
    alerts: {
      noIssues: 'No problems found',
      successful: 'Successful',
      unknownError: 'Unknown error',
      unknownErrorWith: 'Unknown error: {detail}',
      tooManyFiles: 'Too many files',
      colsInsName: 'The file name must be exactly "colInstruction YYYYMMDD.xlsx" ending in a valid date (e.g. colInstruction 20260904.xlsx)',
      colsInsNewer: 'Only a colInstruction newer than the current one is accepted ({latest})',
      extension: 'Only .xlsx and .xlsb files are accepted',
      dateSuffix: 'The file name must end with a YYYYMMDD date',
      dateSuffixYear: 'The file name must end with a YYYYMMDD date (year)',
      dateSuffixMonth: 'The file name must end with a YYYYMMDD date (month)',
      dateSuffixDay: 'The file name must end with a YYYYMMDD date (day)',
    },
  },
  vi: {
    title: 'Tải dữ liệu',
    subtitle: 'Chọn file rồi bấm Gửi. Mỗi lần chỉ chuẩn bị được một file.',
    roles: {
      planning: 'PLANNING',
      cash: 'CASH ACCOUNTANT',
      colsIns: 'COLS INS',
    },
    steps: {
      loadNoteDb: 'Load Note Đặc Biệt',
      checkPlanning: 'Kiểm tra file Planning',
      processPlanning: 'Xử lý Data Planning',
      checkPayment: 'Kiểm tra Payment',
      processPayment: 'Xử lý Payment',
      processPaymentNote: '(Có tác dụng tạo customer trên hệ thống - PLANNING sử dụng để tạo customer)',
      closeFile: 'Chốt File Planning và Payment',
      colsIns: 'Upload Cols Ins',
      colsInsNote: 'Chỉ nhận "colInstruction YYYYMMDD.xlsx" mới hơn bản hiện tại; file được chạy thử với file planning chuẩn trước khi lưu.',
    },
    file: {
      noteDb: 'File Note Đặc Biệt',
      planning: 'File Planning',
      colsIns: 'File ColsIns',
    },
    cancel: 'Huỷ',
    submit: 'Gửi',
    close: 'Đóng',
    colsInsCard: {
      title: 'Danh sách file ColsIns',
      standard: 'File planning chuẩn',
      standardMissing: 'Chưa có — sẽ lưu sau lần "Xử lý Data Planning" thành công tiếp theo',
      current: 'colInstruction đang dùng',
      noWrite: 'Server không có quyền ghi vào {path} — liên hệ admin.',
      fileHeader: 'File',
    },
    download: {
      title: 'Tải file?',
      body: 'Bạn có muốn tải xuống {file}?',
      cancel: 'Huỷ',
      confirm: 'Tải xuống',
      failed: 'Lỗi không tải được file',
    },
    alerts: {
      noIssues: 'Không phát hiện lỗi nào',
      successful: 'Thành công',
      unknownError: 'Lỗi không xác định',
      unknownErrorWith: 'Lỗi không xác định: {detail}',
      tooManyFiles: 'Quá nhiều file',
      colsInsName: 'Tên file phải đúng dạng "colInstruction YYYYMMDD.xlsx" với ngày hợp lệ ở cuối (VD: colInstruction 20260904.xlsx)',
      colsInsNewer: 'Chỉ nhận colInstruction mới hơn bản hiện tại ({latest})',
      extension: 'Đuôi file chỉ chấp nhận xlsx và xlsb',
      dateSuffix: 'Tên file phải kết thúc bằng ngày YYYYMMDD',
      dateSuffixYear: 'Tên file phải kết thúc bằng ngày YYYYMMDD (năm)',
      dateSuffixMonth: 'Tên file phải kết thúc bằng ngày YYYYMMDD (tháng)',
      dateSuffixDay: 'Tên file phải kết thúc bằng ngày YYYYMMDD (ngày)',
    },
  },
}
